import React from 'react';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

const gqlGet = gql`
  query getMultitenantAliases {
    getMultitenantAliases {
      data {
        id: aliasName
        description: friendlyName
      }
      recordCount
    }
  }
`;

export function useMultitenantAliases() {
  const { data } = useQuery(gqlGet, { fetchPolicy: 'network-only' });
  return data ? data?.getMultitenantAliases : null;
}
